<app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"

	[value]="natureMarche.intitule"

	[label]="step3.getintitule"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000|required'"
	[errorMessage]="{'required' : 'ctr_1090_HorsDef', 'maxLength' : 'ctr_1091_HorsDef'}"
	[name]="getUid() + '_SepAtt_intitule'"
>
</app-form-input>

<!---->

<app-type-objCPV
	[uid]="getUid()"
	[parentForm]="parentForm"
	[disabled]="disabled"

	[cPV]="natureMarche.codeCPV"
></app-type-objCPV>

<app-type-nature-marche-choix
	[uid]="getUid()"
	[parentForm]="parentForm"
	[disabled]="disabled"

	[natureMarche]="natureMarche.natureMarche"
></app-type-nature-marche-choix>

<!---->

<app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"

	[value]="natureMarche.description"

	[label]="step3.description"
	[type]="'text'"
	[rule]="'minSize_5|maxSize_2000'"
	[name]="getUid() + '_SepAtt_description'"
>
</app-form-input>
